import React, { FC, useState } from 'react'

import { EuiPanel, EuiLink, EuiFlexGroup, EuiFlexItem, EuiIcon, EuiSpacer, EuiButtonIcon, EuiBadge, EuiText } from '@elastic/eui'

import { MasterCampaignPlanStatus } from 'api/interfaces/MasterCampaignPlan'
import { Persona } from 'api/interfaces/Persona'
import AgencyV2Modal from 'features/planner/components/AgencyV2Modal'

import PersonaDetails from './PersonaDetails'
import PersonaHeader from './PersonaHeader'

export interface PersonaCardProps {
  masterCampaignPlanStatus: MasterCampaignPlanStatus
  persona: Persona
  isExpanded: boolean
  onToggle: () => void
  onEditClick?: () => void
  onDeleteClick?: () => Promise<void>
  onDeleteLoading?: boolean
  showActions?: boolean
}

const PersonaCard: FC<PersonaCardProps> = ({ masterCampaignPlanStatus, persona, isExpanded, onToggle, onEditClick, onDeleteClick, onDeleteLoading = false, showActions = true }) => {
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false)

  const handleDeleteClick = () => {
    setIsDeleteModalVisible(true)
  }

  const onConfirmDeleteClick = async () => {
    await onDeleteClick?.()
    setIsDeleteModalVisible(false)
  }

  return (
    <>
      <EuiPanel paddingSize='l'>
        <EuiFlexGroup>
          <EuiFlexItem grow={false} style={{ marginLeft: '-28px' }}>
            <EuiBadge
              style={{
                backgroundColor: '#f5f5f5',
                color: 'black',
                margin: 'auto',
                borderRadius: '50%',
                width: '32px',
                height: '32px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.15)',
                fontWeight: 'bold',
                fontSize: '14px'
              }}>
              {persona.rank}
            </EuiBadge>
          </EuiFlexItem>
          <EuiFlexItem style={{ marginLeft: '1rem' }}>
            <EuiFlexGroup alignItems='center' justifyContent='spaceBetween' responsive={false}>
              <EuiFlexItem>
                <PersonaHeader persona={persona} />
              </EuiFlexItem>
              {showActions && masterCampaignPlanStatus !== MasterCampaignPlanStatus.TransferredToDsp && (
                <EuiFlexItem grow={false}>
                  <EuiFlexGroup gutterSize='xs' responsive={false}>
                    <EuiFlexItem grow={false}>
                      <EuiButtonIcon iconType='pencil' onClick={onEditClick} aria-label={`Edit ${persona.name}`} size='s' />
                    </EuiFlexItem>
                    <EuiFlexItem grow={false}>
                      <EuiButtonIcon iconType='trash' onClick={handleDeleteClick} aria-label={`Delete ${persona.name}`} size='s' />
                    </EuiFlexItem>
                  </EuiFlexGroup>
                </EuiFlexItem>
              )}
            </EuiFlexGroup>

            <EuiSpacer size='m' />

            {isExpanded && <PersonaDetails persona={persona} />}
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiPanel>
      {isDeleteModalVisible && (
        <AgencyV2Modal isLoading={onDeleteLoading} title='Remove Persona' onClose={() => setIsDeleteModalVisible(false)} confirmButtonText='Remove' onConfirmButtonClick={onConfirmDeleteClick} showCancelButton>
          <EuiText>
            Persona: <strong>{persona.name}</strong> will be removed from the plan.
          </EuiText>
        </AgencyV2Modal>
      )}
    </>
  )
}

export default PersonaCard
